import React, { FC } from 'react'
import { Item } from '@radix-ui/react-dropdown-menu'
import {
  FormControlLabel,
  RadioButton,
  RadioGroup,
} from '@moonpig/launchpad-forms'
import { styled } from '@moonpig/launchpad-utils'

const StyledFormControlLabel = styled(FormControlLabel)`
  padding: 8px;
  height: 54px;
`

const StyledDropdownMenuItem = styled(Item)`
  margin: 1px;

  &:hover {
    outline: none;
  }

  &:nth-child(odd) {
    border-radius: 12px 12px 0 0;
  }

  &:nth-child(even) {
    border-radius: 0 0 12px 12px;
  }
`

type Props = {
  options: { label: string; value: string }[]
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  disabled: boolean
  ariaLabelledBy: string
  inDropdownMenu?: boolean
}

export const SortOptions: FC<Props> = ({
  options,
  value,
  onChange,
  disabled,
  ariaLabelledBy,
  inDropdownMenu = false,
}) => {
  if (inDropdownMenu) {
    return (
      <div aria-labelledby={ariaLabelledBy}>
        {options.map(sortByOption => (
          <StyledDropdownMenuItem
            key={sortByOption.value}
            textValue={sortByOption.label}
            disabled={disabled}
            onSelect={() =>
              onChange({
                target: { value: sortByOption.value },
                currentTarget: { value: sortByOption.value },
              } as React.ChangeEvent<HTMLInputElement>)
            }
          >
            <StyledFormControlLabel
              label={sortByOption.label}
              id={sortByOption.value}
              disabled={disabled}
            >
              <RadioButton
                name="sort-by"
                checked={value === sortByOption.value}
                onChange={onChange}
                value={sortByOption.value}
              />
            </StyledFormControlLabel>
          </StyledDropdownMenuItem>
        ))}
      </div>
    )
  }

  return (
    <RadioGroup name="sort-by" ariaLabelledBy={ariaLabelledBy}>
      {options.map(sortByOption => (
        <StyledFormControlLabel
          label={sortByOption.label}
          id={sortByOption.value}
          key={sortByOption.value}
          disabled={disabled}
        >
          <RadioButton
            checked={value === sortByOption.value}
            onChange={onChange}
            value={sortByOption.value}
          />
        </StyledFormControlLabel>
      ))}
    </RadioGroup>
  )
}
